import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import MDTypography from "components/MDTypography";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import Collapse from "@mui/material/Collapse";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import TextField from "@mui/material/TextField";
import { Link, useNavigate } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import PropTypes from "prop-types";

function Nav({ onSearch }) {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const [open, setOpen] = React.useState(false);
  const [search, setSearch] = React.useState("");

  const handleToggle = () => setOpen(!open);

  const handleLogout = () => {
    sessionStorage.removeItem("role");
    localStorage.removeItem("token");
    localStorage.removeItem("userData");
    sessionStorage.clear();
    navigate("/");
    window.location.reload();
  };

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearch(value);
    if (onSearch) onSearch(value);
  };

  const navLinks = [
    { label: "Belanja", path: "/ecommerce/dashboard" },
    { label: "Checkout", path: "/ecommerce/checkout" },
    { label: "Riwayat Pesanan", path: "/ecommerce/history" },
  ];

  return (
    <AppBar
      position="sticky"
      elevation={0}
      sx={{
        background: "rgba(255, 255, 255, 0.13)",
        backdropFilter: "blur(20px)",
        WebkitBackdropFilter: "blur(20px)",
        boxShadow: "0 4px 30px rgba(0,0,0,0.1)",
        px: { xs: 2, md: 4 }, // padding horizontal seragam
      }}
    >
      <Toolbar sx={{ display: "flex", justifyContent: "space-between", py: 1 }}>
        {/* Brand */}
        <MDTypography
          variant="h6"
          component={Link}
          to="/"
          sx={{
            textDecoration: "none",
            color: "white",
            fontWeight: "bold",
            fontSize: { xs: "1.1rem", md: "1.25rem" },
          }}
        >
          WenMart
        </MDTypography>

        {/* Desktop Menu */}
        {!isMobile && (
          <MDBox sx={{ display: "flex", gap: 3, alignItems: "center" }}>
            <TextField
              variant="outlined"
              size="small"
              placeholder="Cari produk..."
              value={search}
              onChange={handleSearch}
              sx={{
                bgcolor: "white",
                borderRadius: "8px",
                width: { sm: "200px", md: "250px", lg: "300px" },
                "& .MuiOutlinedInput-root": {
                  fontSize: "14px",
                  height: "38px",
                },
              }}
            />
            {navLinks.map((link) => (
              <MDTypography
                key={link.path}
                variant="h6"
                component={Link}
                to={link.path}
                sx={{
                  textDecoration: "none",
                  color: "white",
                  fontWeight: 500,
                  "&:hover": { color: "primary.main" },
                }}
              >
                {link.label}
              </MDTypography>
            ))}
            <MDButton color="primary" size="small" onClick={handleLogout}>
              Logout
            </MDButton>
          </MDBox>
        )}

        {/* Mobile Toggle Button */}
        {isMobile && (
          <IconButton color="inherit" onClick={handleToggle}>
            <MenuIcon />
          </IconButton>
        )}
      </Toolbar>

      {/* Mobile Collapse Menu */}
      {isMobile && (
        <Collapse in={open} timeout="auto" unmountOnExit>
          <MDBox
            sx={{
              display: "flex",
              flexDirection: "column",
              p: 2,
              gap: 2,
              background: "#fff",
            }}
          >
            <TextField
              variant="outlined"
              size="small"
              placeholder="Cari produk..."
              value={search}
              onChange={handleSearch}
              sx={{
                bgcolor: "white",
                borderRadius: "8px",
                "& .MuiOutlinedInput-root": {
                  fontSize: "14px",
                  height: "38px",
                },
              }}
            />
            {navLinks.map((link) => (
              <MDTypography
                key={link.path}
                variant="body1"
                component={Link}
                to={link.path}
                onClick={() => setOpen(false)}
                sx={{
                  textDecoration: "none",
                  color: "black",
                  fontWeight: 500,
                  "&:hover": { color: "primary.main" },
                }}
              >
                {link.label}
              </MDTypography>
            ))}
            <MDButton color="primary" size="small" onClick={handleLogout}>
              Logout
            </MDButton>
          </MDBox>
        </Collapse>
      )}
    </AppBar>
  );
}

Nav.propTypes = {
  onSearch: PropTypes.func,
};

Nav.defaultProps = {
  onSearch: () => {},
};

export default Nav;
